var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.706,
    height: 48.414,
    viewBox: "0 0 50.706 48.414",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_icon",
    transform: "translate(9582.369 11595.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_75665",
    "data-name": "Path 75665",
    d: "M30.087,8.263q1.349-1.06,2.7-2l-.019-.009,1.07-.713c.151-.1.3-.193.452-.291l.1-.065A41.9,41.9,0,0,1,44.925.126a45.032,45.032,0,0,0-9.542,2.707C29.412,5.05,24.613,6.832,20.475,0q-.148.557-.269,1.119c-.029.134-.056.269-.082.4q-.1.5-.179,1c-.017.109-.038.217-.054.327-.058.4-.1.8-.145,1.2-.017.17-.032.341-.047.512-.024.289-.043.579-.059.868-.011.2-.021.406-.028.61q-.017.5-.018,1c0,.212,0,.426.007.639s.01.427.018.641c.008.231.016.46.029.692.006.105.015.21.022.316q.054.822.147,1.662c.012.11.023.219.036.329.038.318.079.637.126.959.007.049.015.1.022.148.06.41.129.818.2,1.224.036.2.076.41.116.615q.054.285.111.569.082.4.172.8.036.162.073.324c.074.321.15.643.232.967l.007.028a70.38,70.38,0,0,1,9.175-8.686",
    transform: "translate(-9592.82 -11595.801)",
    fill: "#ff8110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75666",
    "data-name": "Path 75666",
    d: "M67.947,14.195v-.021l.477.376A43.007,43.007,0,0,1,77.8,24a45.211,45.211,0,0,0-5.492-8.17c-3.952-4.992-7.128-9-1.911-15.047-.08,0-.16,0-.24.008l-.043,0q-.529.036-1.055.094l-.032,0a35.336,35.336,0,0,0-14.6,5.537,69.818,69.818,0,0,1,11.309,6.2q1.144.774,2.21,1.568",
    transform: "translate(-9611.399 -11596.22)",
    fill: "#ff8110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75667",
    "data-name": "Path 75667",
    d: "M72.54,51.2l-.328.884-.3.822c-.016.044-.034.085-.05.129q-.277.743-.58,1.486c-.055.134-.111.265-.166.4-.177.424-.358.847-.549,1.269-.1.231-.212.455-.319.682-.154.326-.3.652-.466.975-.28.563-.568,1.114-.865,1.65l-.062.111q-.28.5-.576,1c-.04.067-.079.134-.119.2q-.279.461-.572.913c-.041.063-.081.129-.122.192q-.333.509-.685,1.008c-.106.151-.216.3-.324.444s-.221.308-.336.46a44.927,44.927,0,0,0,6.132-7.807c3.526-5.3,6.361-9.566,13.721-6.47-2.088-5.381-6.047-9.867-10.312-13.427a68.916,68.916,0,0,1-3.148,15.1Z",
    transform: "translate(-9617.634 -11615.062)",
    fill: "#ff8110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75668",
    "data-name": "Path 75668",
    d: "M24.937,74.9l.013.031-1.137-.047a42.565,42.565,0,0,1-12.138-2.137,44.986,44.986,0,0,0,9.3,3.41c6.134,1.714,11.064,3.091,10.394,11.058l.153-.127q.237-.2.471-.4c.085-.074.17-.15.254-.225q.209-.187.415-.379c.083-.077.166-.155.248-.233q.237-.228.47-.464c.054-.055.11-.108.163-.163q.311-.318.614-.651c.05-.055.1-.111.148-.166q.241-.268.477-.545l.155-.184q.265-.316.526-.643l.057-.072c.289-.366.566-.74.838-1.118.132-.183.259-.373.389-.561s.266-.385.4-.581c.159-.242.314-.489.469-.737.087-.14.174-.279.259-.42q.267-.442.526-.9l.146-.259c.2-.357.395-.719.587-1.089l.034-.066q.972-1.886,1.818-4A68.751,68.751,0,0,1,24.937,74.9",
    transform: "translate(-9588.596 -11634.601)",
    fill: "#ff8110"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75669",
    "data-name": "Path 75669",
    d: "M9.4,26.055a45.61,45.61,0,0,1-1.635-9.066c0-.014,0-.027,0-.04-.036-.522-.063-1.04-.077-1.552v-.029c-.014-.532-.018-1.059-.008-1.579A44.787,44.787,0,0,0,7.3,23.751c.266,6.361.48,11.473-7.3,13.3l.22.139q.577.363,1.181.7c.152.084.3.17.457.251.405.215.822.419,1.245.616q.345.16.695.311.524.227,1.066.436.491.19.988.362.425.148.86.286.669.211,1.346.394.257.07.517.136.958.244,1.925.437l.15.03a44.958,44.958,0,0,0,5.591.715A69.183,69.183,0,0,1,9.432,26.139Z",
    transform: "translate(-9582.369 -11603.155)",
    fill: "#ff8110"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo_icon.b5afa7e9480f341f090d08af946acd1f.svg";
export { ForwardRef as ReactComponent };